import { useState } from "react";
import { MessageCircle, Copy, ExternalLink } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";

export function WhatsAppShare({ shipment: s, onChanged }) {
  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [mobile, setMobile] = useState("");

  const load = async () => {
    try {
      const r = await api.get(`/shipments/${s.shipment_id}/share-message`);
      setData(r.data); setMobile(r.data.mobile || ""); setOpen(true);
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : "Could not prepare message");
    }
  };

  const digits = mobile.replace(/\D/g, "");
  const waNumber = digits.length === 10 ? `91${digits}` : digits;
  const log = (channel) => api.post(`/shipments/${s.shipment_id}/share-log`, { channel, to: mobile || null }).then(() => onChanged?.()).catch(() => {});

  const sendWhatsApp = () => {
    if (!waNumber) { toast.error("Enter the customer's WhatsApp number"); return; }
    window.open(`https://wa.me/${waNumber}?text=${encodeURIComponent(data.text)}`, "_blank", "noopener");
    log("whatsapp"); toast.success("WhatsApp opened — message pre-filled"); setOpen(false);
  };
  const copy = async () => {
    await navigator.clipboard.writeText(data.text);
    log("copy"); toast.success("Message copied");
  };

  const shared = s.customer_shares?.length || 0;
  return (
    <>
      <Button size="sm" variant="outline" className="border-signal-green/50 text-signal-green hover:bg-signal-green/10" onClick={load} data-testid={`shipment-whatsapp-${s.shipment_id}`}>
        <MessageCircle className="w-3.5 h-3.5 mr-1" /> WhatsApp LR/Invoice{shared ? ` (${shared})` : ""}
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg" data-testid="whatsapp-share-dialog">
          <DialogHeader><DialogTitle className="font-heading uppercase">Share dispatch details — {s.shipment_id}</DialogTitle></DialogHeader>
          {data && (
            <div className="space-y-3">
              <div>
                <label className="text-[10px] font-mono uppercase tracking-widest text-muted-foreground">Customer WhatsApp number</label>
                <Input value={mobile} onChange={(e) => setMobile(e.target.value)} placeholder="10-digit mobile (India) or with country code" data-testid="whatsapp-mobile-input" />
                {!data.mobile && <p className="text-xs text-signal-amber mt-1">No mobile on customer master — enter one to send.</p>}
              </div>
              <pre className="text-xs whitespace-pre-wrap bg-muted/40 border border-border rounded p-3 max-h-60 overflow-auto font-sans" data-testid="whatsapp-message-preview">{data.text}</pre>
              {data.shared.length > 0 && (
                <p className="text-xs text-muted-foreground" data-testid="whatsapp-shared-log">Last shared by {data.shared[data.shared.length - 1].by} via {data.shared[data.shared.length - 1].channel}</p>)}
              <div className="flex gap-2 justify-end">
                <Button variant="outline" size="sm" onClick={copy} data-testid="whatsapp-copy-btn"><Copy className="w-3.5 h-3.5 mr-1" /> Copy message</Button>
                <Button size="sm" className="bg-signal-green hover:bg-signal-green/90 text-white" onClick={sendWhatsApp} data-testid="whatsapp-send-btn"><ExternalLink className="w-3.5 h-3.5 mr-1" /> Open WhatsApp</Button>
              </div>
            </div>)}
        </DialogContent>
      </Dialog>
    </>
  );
}
